// <product-gallery>: clickable thumbnails and hover zoom on the main image.
class ProductGallery extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-thumb]').forEach((btn) => btn.addEventListener('click', () => this.show(btn.dataset.thumb)));
    this.zoom = this.querySelector('[data-zoom]');
    // Zoom only where a mouse/trackpad can hover; touch devices keep the plain image.
    if (this.zoom && window.matchMedia('(hover: hover) and (pointer: fine)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.zoom.classList.add('cursor-zoom-in');
      this.zoom.addEventListener('mousemove', (e) => this.move(e));
      this.zoom.addEventListener('mouseleave', () => this.reset());
    }
  }

  show(id) {
    this.reset();
    this.querySelectorAll('[data-slide]').forEach((s) => s.classList.toggle('hidden', s.dataset.slide !== id));
    this.querySelectorAll('[data-thumb]').forEach((b) => {
      const on = b.dataset.thumb === id;
      b.classList.toggle('border-link', on);
      b.classList.toggle('border-transparent', !on);
      if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
    });
  }

  current() { return this.querySelector('[data-slide]:not(.hidden) [data-zoom-img]'); }

  move(e) {
    const img = this.current();
    if (!img) return;
    const r = this.zoom.getBoundingClientRect();
    const x = ((e.clientX - r.left) / r.width) * 100;
    const y = ((e.clientY - r.top) / r.height) * 100;
    img.style.transformOrigin = `${x}% ${y}%`;
    img.style.transform = 'scale(1.5)';
  }

  reset() {
    this.querySelectorAll('[data-zoom-img]').forEach((img) => { img.style.transform = ''; img.style.transformOrigin = ''; });
  }
}
if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);
